import { useState, useEffect } from "react";

const typeMatchesEvent = (type, event) => {
  const eventOptionsMatch =
    !type.eventOptions ||
    type.eventOptions.every((option) => event.options && event.options[option.option] === option.value);

  if (!type.eventTypes.includes(event.eventType) || !eventOptionsMatch) {
    return false;
  }

  if (
    type.subTypeIgnore &&
    type.subTypeIgnore.includes(event.subType)
  ) {
    return false;
  }

  if (!(event.success === type.success || type.success === null)) {
    return false;
  }

  if (!type.subType) {
    return true;
  }

  switch (type.subType.operator) {
    case "is":
      return type.subType.subType === event.subType;
    case "not":
      return type.subType.subType !== event.subType;
    default:
      return false;
  }
};

export const useCanEdit = (props, events) => {
  const { workFlow } = props;
  const [canEdit, setCanEdit] = useState(false);

  useEffect(() => {
    if (workFlow && workFlow.modify && workFlow.modify.types) {
      events.map((event) => {
        workFlow.modify.types.map((type) => {
          if (typeMatchesEvent(type, event)) {
            setCanEdit(true);
          }
          return true;
        });
        return true;
      });
    }
    // eslint-disable-next-line
  }, [props]);

  return [canEdit];
};
